import React, { useEffect } from "react";

const CustomDrawer = ({ children, isOpen, handleClose, maxWidth }) => {
  // Custom Drawer
  useEffect(() => {
    const { body } = document;
    if (body) body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <main
      className={`fixed overflow-hidden z-[9999] bg-gray-850 bg-opacity-25 inset-0 transform ease-in-out ${
        isOpen ? "opacity-100 translate-x-0" : "opacity-0 translate-x-full"
      }`}
    >
      <section
        className={`w-screen ${maxWidth} bg-black text-white right-0 absolute h-screen shadow-xl transition-all transform lg:rounded-xl lg:w-[30%] ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div>{children}</div>
      </section>

      <section
        className="w-screen h-full cursor-pointer"
        onClick={() => handleClose()}
      />
    </main>
  );
};

export default CustomDrawer;
